import { Autocomplete, AutocompleteProps } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { optionsFilter } from './utils'

type FeatureField = {
  feature?: string | null
}

interface Props<Values extends FeatureField> extends Omit<AutocompleteProps, 'form'> {
  form: UseFormReturnType<Values>
}

export default function FeatureInput<Values extends FeatureField>({ form, description, ...props }: Props<Values>) {
  return (
    <Autocomplete
      label="Cecha"
      description={description || 'Cecha produktu, np. kolor lub podkład.'}
      placeholder="Oxford"
      data={[
        { group: 'Kolor', items: ['Biały', 'Écru'] },
        { group: 'Podkład', items: ['Oxford', 'Velluto', 'Velvet', 'UNI', 'Żakard'] },
      ]}
      filter={optionsFilter}
      {...props}
      {...form.getInputProps('feature')}
    />
  )
}
